package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.repository.GameTableRepository
import fr.manyverse.app.domain.repository.UniverseRepository

class CreateGameTableUseCase(
    private val gameTableRepository: GameTableRepository,
    private val universeRepository: UniverseRepository
) {
    suspend operator fun invoke(
        universeId: String,
        gameMasterId: String,
        name: String
    ): Result<GameTable> {
        val universe = universeRepository.getUniverseById(universeId)
            .getOrElse { return Result.failure(it) }
            ?: return Result.failure(ValidationError("Universe not found: $universeId"))

        return gameTableRepository.createTable(
            universeId = universeId,
            universeConfig = universe.config,
            gameMasterId = gameMasterId,
            name = name
        )
    }
}
